import { getAxiosClient } from '../../client';
import { makeApiRequest } from '../../makeApiRequest';
import type { ApiResponse } from '../../responses';
import { CategoriesEndpoints } from './categoriesEndpoints';
import type { ICategoriesService } from './ICategoriesService';
import type { GetCategoryPickerResponse } from './responses';

type CategoriesServiceOptions = {
    baseUrl: string;
};

export class CategoriesService implements ICategoriesService {
    private readonly baseUrl: string;

    constructor({ baseUrl }: CategoriesServiceOptions) {
        this.baseUrl = baseUrl;
    }

    public getCategoryPicker(): Promise<
        ApiResponse<GetCategoryPickerResponse>
    > {
        const url = CategoriesEndpoints.picker();
        return makeApiRequest<GetCategoryPickerResponse>(
            getAxiosClient({ baseURL: this.baseUrl }).get(url),
        );
    }
}
